import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class PollinationTypeService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<PollinationType[]> => {
    return this.apiHttp.get<PollinationType[]>("pollinationtypes");
  };

  public get = (id: number): Observable<PollinationType> => {
    return this.apiHttp.get<PollinationType>(`pollinationtypes/${id}`);
  }
}

export interface PollinationType {
  id: number;
  name: string;
  geNameRequired: boolean;
  orderNumber: number;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/pollination-type.service.ts